import { render, staticRenderFns } from "./_BroadcastList.vue?vue&type=template&id=964dc47e&scoped=true&"
import script from "./_BroadcastList.vue?vue&type=script&lang=js&"
export * from "./_BroadcastList.vue?vue&type=script&lang=js&"
import style0 from "./_BroadcastList.vue?vue&type=style&index=0&id=964dc47e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "964dc47e",
  null
  
)

export default component.exports